export default function handleStickyHeader() {
  const header = document.querySelector(".sticky-nav");
  if (!header) return;

  function onScroll() {
    if (window.scrollY > 0 && window.scrollY <= 200) return;
    if (window.scrollY === 0) header.classList.remove("isSticky");
    else header.classList.add("isSticky");
  }

  window.addEventListener("scroll", onScroll);
}
